import { CORNERS, FIXED_INDENTS } from 'vars/index'

export const AvatarBlockCorners = {
  CORNERS_0: CORNERS.CORNERS_0,
  CORNERS_10: CORNERS.CORNERS_10,
  CORNERS_20: CORNERS.CORNERS_20,
  CORNERS_30: CORNERS.CORNERS_30,
  CORNERS_50: CORNERS.CORNERS_50,
} as const
export type AvatarBlockCorners =
  (typeof AvatarBlockCorners)[keyof typeof AvatarBlockCorners]

export const AvatarBlockDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type AvatarBlockDirection =
  (typeof AvatarBlockDirection)[keyof typeof AvatarBlockDirection]

export const AvatarBlockJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type AvatarBlockJustifyContent =
  (typeof AvatarBlockJustifyContent)[keyof typeof AvatarBlockJustifyContent]

export const AvatarBlockAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type AvatarBlockAlignItems =
  (typeof AvatarBlockAlignItems)[keyof typeof AvatarBlockAlignItems]

type RowGapKey = 'SIZE_0' | 'SIZE_20' | 'SIZE_40'
export const AvatarBlockRowGaps: Record<RowGapKey, readonly [string]> = {
  SIZE_0: [FIXED_INDENTS.INDENT_0],
  SIZE_20: [FIXED_INDENTS.INDENT_20],
  SIZE_40: [FIXED_INDENTS.INDENT_40],
} as const
export type AvatarBlockRowGap =
  (typeof AvatarBlockRowGaps)[keyof typeof AvatarBlockRowGaps]

type ColumnGapKey = 'SIZE_0' | 'SIZE_20' | 'SIZE_40'
export const AvatarBlockColumnGaps: Record<ColumnGapKey, readonly [string]> = {
  SIZE_0: [FIXED_INDENTS.INDENT_0],
  SIZE_20: [FIXED_INDENTS.INDENT_20],
  SIZE_40: [FIXED_INDENTS.INDENT_40],
} as const
export type AvatarBlockColumnGap =
  (typeof AvatarBlockColumnGaps)[keyof typeof AvatarBlockColumnGaps]

type PaddingKey = 'SIZE_0' | 'SIZE_10'
export const AvatarBlockPaddings: Record<
  PaddingKey,
  readonly [string, string, string, string]
> = {
  SIZE_0: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_10: [
    FIXED_INDENTS.INDENT_10,
    FIXED_INDENTS.INDENT_10,
    FIXED_INDENTS.INDENT_10,
    FIXED_INDENTS.INDENT_10,
  ],
} as const
export type AvatarBlockPadding =
  (typeof AvatarBlockPaddings)[keyof typeof AvatarBlockPaddings]
